import { render, staticRenderFns } from "./HeadImgUpload.vue?vue&type=template&id=881a6ab0"
import script from "./HeadImgUpload.vue?vue&type=script&lang=js"
export * from "./HeadImgUpload.vue?vue&type=script&lang=js"
import style0 from "./HeadImgUpload.vue?vue&type=style&index=0&id=881a6ab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports